import styled from 'styled-components';
import dotIconImg from 'images/dot_icon.png'

export const Fitgrouparea = styled.div `
    padding-bottom: calc(100vw*(120/375));
`
export const Imgtit = styled.p `
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    letter-spacing: 0.32px;
`
export const Titbar = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: calc(100vw*(17/375)) calc(100vw*(11/375)) calc(100vw*(16/375)) calc(100vw*(17/375));
`

export const Dot = styled.label`
    display:block;
    width: calc(100vw*(16/375));
    height: calc(100vw*(16/375));
    background-image : url(${dotIconImg});
    background-repeat: no-repeat;
    background-size: calc(100vw*(16/375));
`
export const Fileinput = styled.input`
    display:none;
`
export const FitChangeinner = styled.div`
    padding-top: calc(100vw*(51/375));
`
export const Fitimages = styled.div`
    width: 100%;
    height: calc(100vw*(240/375));
    background-color: #f5f5f5;
`
export const Groupname = styled.input`
    width: calc(100vw*(342/375));
    height: calc(100vw*(40/375));
    border-radius: calc(100vw*(5/375));
    border: solid calc(100vw*(1/375)) #d5d5d5;
    background-color: #ffffff;
    font-size: calc(100vw*(14/375));
    padding-left : calc(100vw*(11/375));
    margin-left : calc(100vw*(16/375));

    &::placeholder {
        color: #c6c6c6;
    }
    &:focus {
        border: solid calc(100vw*(1/375)) #ffcf19;
    }
`

export const Fitinput = styled.input`
    display:none;
`
export const Fitlabel = styled.label`
    display: block;
    text-align: center;
    width: 100%;
    height: 100%;
    padding: calc(100vw*(80/375)) 0;
`
export const Fitimg = styled.span`
    display:block;
    width: calc(100vw*(49/375));
    height: calc(100vw*(40/375));
    margin: 0 auto calc(100vw*(10.5/375));
`
export const Fitxt = styled.span`
    font-size: calc(100vw*(11/375));
    color: #7f7f7f;
`
export const PreviewImg = styled.img`
    object-fit: cover;
    height: 100%;
    width: 100%;
`
export const Subtit = styled.p`
    font-size: calc(100vw*(11/375));
    color: #707070;
    margin-top: ${props=>props.marginTop};
    padding-left: calc(100vw*(17/375));
    padding-bottom: ${props=>props.paddingBottom};
`